require(
      "!../../../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../../../node_modules/json-loader/index.js!./es-2020-scholarship-program-winning-video-entries.json") })
        }
      }, "path---es-2020-scholarship-program-winning-video-entries");
     }
    


//////////////////
// WEBPACK FOOTER
// /home/circleci/repo/~/gatsby-module-loader?name=path---es-2020-scholarship-program-winning-video-entries!./.cache/json/es-2020-scholarship-program-winning-video-entries.json
// module id = 2011
// module chunks = 231608221292675